import { render, staticRenderFns } from "./simplifyPreReceipt.vue?vue&type=template&id=2965ee9e&scoped=true"
import script from "./simplifyPreReceipt.vue?vue&type=script&lang=js"
export * from "./simplifyPreReceipt.vue?vue&type=script&lang=js"
import style0 from "./simplifyPreReceipt.vue?vue&type=style&index=0&id=2965ee9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965ee9e",
  null
  
)

export default component.exports